import { render, staticRenderFns } from "./rh_cabecalho.vue?vue&type=template&id=4d92053c&scoped=true&"
import script from "./rh_cabecalho.vue?vue&type=script&lang=js&"
export * from "./rh_cabecalho.vue?vue&type=script&lang=js&"
import style0 from "./rh_cabecalho.vue?vue&type=style&index=0&id=4d92053c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d92053c",
  null
  
)

export default component.exports